import { useMemo } from 'react';

import type { ElectronAPI } from 'src/types/electron';

/**
 * Check if the app is running in Electron.
 */
export const isElectron = (): boolean => {
  return (
    typeof window !== 'undefined' &&
    window.electronAPI !== undefined &&
    window.electronAPI.isElectron === true
  );
};

/**
 * Get the Electron API if available.
 * Returns undefined when running in a browser.
 */
export const getElectronAPI = (): ElectronAPI | undefined => {
  if (isElectron()) {
    return window.electronAPI;
  }
  return undefined;
};

/**
 * Hook to access the Electron API.
 * Returns the API object when running in Electron, undefined otherwise.
 */
export const useElectron = (): ElectronAPI | undefined => {
  return useMemo(() => getElectronAPI(), []);
};

/**
 * Hook to check if running in Electron.
 */
export const useIsElectron = (): boolean => {
  return useMemo(() => isElectron(), []);
};
